import React from 'react';
import { Button } from 'reactstrap';
import { sortBy, get, omit, keyBy, } from 'lodash';
import { Link } from 'react-router-dom';
import { useToggle } from 'react-use';
import { toast } from 'react-toastify';
import { omitBy, } from 'lodash';

import firebase, { functions, } from '../../firebase';
import { staffFields, adminFields, } from '../../shared/models/user';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import AdminPage from '../hocs/AdminPage';
import ModelFormModal from '../modals/ModelFormModal';
import EditButton from '../EditButton';
import ProgressButton from '../ProgressButton';
import TenantTags from '../TenantTags';

const db = firebase.firestore();
const updateUser = functions.httpsCallable('updateUser');
const usersRef = db.collection('users');
const tenantsRef = db.collection('tenants');
const tagsRef = db.collection('tags');
const createUser = functions.httpsCallable('createUser');

export default AdminPage(function AdminUsers (props) {
  const [showsFormModal, toggleFormModal] = useToggle(false);
  const users = useCollectionSubscription(usersRef.orderBy('email'));
  const tenants = useCollectionSubscription(tenantsRef);
  const tags = useCollectionSubscription(tagsRef.orderBy('createdAt'));
  const tenantsById = keyBy(tenants, 'id');
  const tagsById = keyBy(tags, 'id');
  const sortedUsers = sortBy(users, _ => get(tenantsById, [_.tenantId, 'id']));
  const onSubmitForm = async (values) => {
    const { displayName, staffId, password, } = values;
    try {
      await createUser({ displayName, email: `${staffId}@wizzlinx.com`, password, isStaff: true, });
      toast.success('追加しました');
    } catch(e) {
      toast.error('失敗しました');
      console.error(e);
    }
    toggleFormModal(false);
  };

  return (
    <div className="admin-users container-fluid">
      <div className="p-4 bg-white my-4">
        <div className="d-flex justify-content-center mb-3">
          <h4>ユーザー管理</h4>
        </div>
        <div className="d-flex justify-content-end mb-3">
          <Button className="ml-2" color="primary" onClick={toggleFormModal}>
            <span className="fas fa-plus mr-1" />
            スタッフ追加
          </Button>
        </div>
        <div className="mt-4 overflow-scroll">
          <table className="table sticky-table">
            <thead className="thead-light text-center">
              <tr className="text-nowrap">
                <th>テナント</th>
                <th>ユーザー名</th>
                <th>メールアドレス</th>
                <th>電話番号</th>
                <th>ID</th>
                <th>管理者</th>
                <th>スタッフ</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                sortedUsers.map((user) => {
                  const { id, ref, email, displayName, phone, tenantId, admin = false, isStaff = false, enablesShippingWithQuantity = false, } = user;
                  const tenant = tenantsById[tenantId];
                  const beforeUpdate = async ({ password }) => {
                    password && await updateUser({ uid: id, password });
                  };
                  const onClickVerifyEmail = async () => {
                    if(!window.confirm('本当にメール認証済みにしますか？')) return;

                    await updateUser({ uid: id, emailVerified: true, });
                  };

                  return (
                    <tr key={id}>
                      <td>
                        {
                          tenant != null && (
                            <div>
                              <div className="font-weight-bold">
                                {tenant.id}
                              </div>
                              <Link to={`/admin/tenants/${tenant.id}`}>
                                {tenant.name}
                              </Link>
                              <TenantTags tagIds={tenant.tagIds} tagsById={tagsById} />
                              {
                                tenant.amacodeIntegratedAt && (
                                  <div className={`d-block small badge badge-${tenant.amacodeStatus ? 'success' : 'warning'}`}>
                                    Amacode連携済み
                                    ({tenant.amacodeStatus.toString()})
                                  </div>
                                )
                              }
                            </div>
                          )
                        }
                      </td>
                      <td>
                        {displayName}
                        {enablesShippingWithQuantity && <div><span className="badge badge-info">数量入力出荷有効</span></div>}
                      </td>
                      <td>
                        {email}
                      </td>
                      <td>
                        {phone}
                      </td>
                      <td>
                        {id}
                      </td>
                      <td>
                        {admin && '管理者'}
                      </td>
                      <td>
                        {isStaff && 'スタッフ'}
                      </td>
                      <td className="text-nowrap text-right">
                        {
                          isStaff && (
                            <EditButton
                              itemRef={ref}
                              processValues={_ => omit(_, ['password'])}
                              FormModal={ModelFormModal}
                              formProps={{
                                title: '編集',
                                fields: {
                                  displayName: staffFields.displayName,
                                  password: {
                                    ...staffFields.password,
                                    validations: omit(staffFields.password.validations, ['required']),
                                  },
                                  enablesShippingWithQuantity: staffFields.enablesShippingWithQuantity,
                                },
                              }}
                              beforeUpdate={beforeUpdate}
                            />
                          )
                        }
                        <ProgressButton className="ml-1" process={onClickVerifyEmail}>
                          メール認証済みにする
                        </ProgressButton>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </div>
      {showsFormModal && <ModelFormModal title="スタッフ追加" fields={staffFields} isOpen onClickClose={toggleFormModal.bind(null, false)} onSubmit={onSubmitForm} />}
    </div>
  );
});
